module.exports = __webpack_public_path__ + "static/media/planning_title_en.67c7ff6a.png";